import OrganisationDetails from "./details"
import { Consumer, Provider, OrganisationDetailsContext } from "./details.context"

export { Consumer, Provider, OrganisationDetailsContext }
export default OrganisationDetails
